import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, onActivated, defineAsyncComponent } from "vue";
import HomeIndex from "@/components/home/HomeIndex.vue";
import Newsletter from "@/components/home/Newsletter.vue";
import { checkInvite, nativeToLogin, nativeToNewWeb, toDownloadApp } from "@/uitls/native";
import HomeFootball from "@/components/home/HomeFootball.vue";
import HomeWorldCup from "@/components/home/HomeWorldCup.vue";

import { usePiniaState } from "@/store/userPinia";
import { storeToRefs } from "pinia";
import { serverConfigPiniaState } from "@/store/serverConfig";
import router from "@/router";
import { formatDate, getQueryVariable, YMPush } from "@/uitls/uitls"
import { Storage } from "@/uitls/Storage";
import { useRoute } from "vue-router";
import Platform from "@/config/platform";
import EventBus from "@/uitls/EventBus";
import { cheackQuery } from "@/uitls/native";
import { useI18n } from 'vue-i18n'
import { getVersion, encryptionHomeOptionType } from "@/api/php/home";
import config from '@/uitls/version.json';

export default /*#__PURE__*/_defineComponent({
  name: 'Home',
  setup(__props, { expose }) {
  expose();

const curversion = process.env.VUE_APP_VERSION as string;
const { t } = useI18n()

const HomeIndexVi = defineAsyncComponent(() =>
  import("@/components/home/HomeIndex_vi.vue")
);
const ConfigpiniaStore = serverConfigPiniaState();
const {
  home_red_url_type,
  home_red_url,
  alertToActivityId,
  is_has_history,
  is_home_down_tab,
  forever_url,
  home_lefttop_white_gif,
  home_lefttop_black_gif,
} = storeToRefs(ConfigpiniaStore);
const { getConfig } = ConfigpiniaStore;
const route = useRoute();
const piniaStore = usePiniaState();
const { toLogin } = piniaStore;
const activeColor = process.env.VUE_APP_DOWNLOAD_COLOR as string;
const activeFontColor = process.env.VUE_APP_DOWNLOAD_FONT_COLOR as string;
const active = ref(0);
const WORLD_CUP_TAB_TYPE = 8;

const homexbod = require(`@/assets/${process.env.VUE_APP_NAME}/home-ad-box.png`)
const homexadBtn = require(`@/assets/${process.env.VUE_APP_NAME}/home-ad-btn.png`)
const searchIcon = require(`@/assets/images/msgsearch.png`)

// const downLogo = require(`@/assets/${process.env.VUE_APP_NAME}/home_down_logo_${process.env.VUE_APP_CHANNEL}.gif`);
// const aboutLogo = require(`@/assets/${process.env.VUE_APP_NAME}/logob_${process.env.VUE_APP_CHANNEL}.gif`);
const url_list_close = require("@/assets/images/url_list_close.png");
const url_list_ok = require(`@/assets/${process.env.VUE_APP_NAME}/url_list_ok.png`);
const url_list_con_title = require(`@/assets/${process.env.VUE_APP_NAME}/url_list_con_title.png`);

//今日签到了没？
const isQD = ref(false)
const time5 = ref(true)
const homeTabs = ref<any[]>([])
const showHomeTabs = ref(false)
let { os, tabIdx } = route.query;
const standalone = Platform.standalone;
let ios = /iPhone|iPad|iPod/i.test(navigator.userAgent)

const th = process.env.VUE_APP_Language as string;
const appname = process.env.VUE_APP_TITLE as string;
const appChannel = process.env.VUE_APP_NAME as string;

onActivated(() => {
  // console.log('获取版本');
  // getV()
})
onMounted(() => {
  cheackQuery(route);
  toLogin();
  checkQD();
  checkWebclip();
  YMPush("MAIN", "HomePage")
  if (Platform.client != 'h5') {
    getConfig()
  }
  getHomeTabs();
  // const { match_id, match_type, ax } = to.query;
  const mq = getQueryVariable('mq');
  const match_id = getQueryVariable('match_id');
  const match_type = getQueryVariable('match_type');
  const ax = getQueryVariable('ax');
  // if (ax == "12" && !mq) {

  //   router.push(`/player?mt=${match_type}&mi=${match_id}&mq=1`)
  // }
  if (ax == "12" && !mq) {
    router.push(`/player?mt=${match_type}&mi=${match_id}`)
  }

  // if (th == 'th') {
  //   showThXY()
  // }   
  let idx = Number(tabIdx as string)
  setTimeout(() => {
    if (is_has_history.value && idx == 5) {
      active.value = 5
    }
  }, 2000);
  setTimeout(() => {
    time5.value = false;
  }, 5500)

});

const getHomeTabs = async () => {
  let res: any = await encryptionHomeOptionType();
  console.log('getHomeTabs:' + JSON.stringify(res));
  homeTabs.value = res.code == 200 && Array.isArray(res.data) ? res.data : [];
  showHomeTabs.value = true
}

// const getV = async () => {
//   const now = Date.now();
//   const versionTime = await Storage.get('versionTime');
//   console.log('version', curversion);

//   
//   if (versionTime == null || (now - versionTime) > 60 * 60 * 1000) {
//     const v: any = await getVersion({ version: curversion });
//     if (v && v.code == 200 && v.data && v.data.version) {
//       const serverVersion = String(v.data.version); // 后台返回的版本号
//       const localVersion = String(curversion); // 本地版本号
//       console.log('reqversion', serverVersion);
//       // 调用版本比较函数
//       if (compareVersions(serverVersion, localVersion) > 0) {
//         console.log("刷新缓存=======>");
//         setTimeout(() => {

//           window.location.reload();
//         }, 800);
//       }

//       Storage.set("versionTime", now); // 更新版本检查时间
//     }
//   }
// };

/**
 * 比较两个版本号
 * @param {string} server - 服务器版本号
 * @param {string} local - 本地版本号
 * @returns {number} - 返回 1 表示服务器版本号较大，-1 表示本地版本号较大，0 表示相等
 */
const compareVersions = (server, local) => {
  const serverParts = server.split('.').map(Number); // 拆分并转换为数字数组
  const localParts = local.split('.').map(Number);

  const maxLength = Math.max(serverParts.length, localParts.length);
  for (let i = 0; i < maxLength; i++) {
    const serverPart = serverParts[i] || 0; // 默认值为 0
    const localPart = localParts[i] || 0;
    if (serverPart > localPart) return 1; // 服务器版本号较大
    if (serverPart < localPart) return -1; // 本地版本号较大
  }
  return 0; // 版本号相等
};

//新手引导
const newGuide = () => {
  const newGuide = Storage.get("newGuide");
  if (newGuide == null) {
    //开启新手引导
    toGuide.value = true;
  }
}
//开启新手引导弹窗
const toGuide = ref(false)
//新手弹窗第几张
const guideType = ref(0)
//下一张
const nextGuide = () => {
  if (guideType.value == 4) {
    Storage.set("newGuide", '1');
    toGuide.value = false;
    window.scroll({ top: 0, left: 0, behavior: "auto" });
    checkAlertAvt()
    return;
  }
  guideType.value++
  if (guideType.value == 2) {
    scrollToAnchor()
  }
}
//动态class
// const getClass = () => {
//   return `guide${guideType.value}`
// }
//关闭引导
// const offGuide = () => {
//   Storage.set("newGuide", '1');
//   toGuide.value = false;
//   window.scroll({ top: 0, left: 0, behavior: "auto" });
//   checkAlertAvt()
// }
//滚动到锚点
const scrollToAnchor = () => {
  let anchorElement = document.getElementById("activity1");
  if (anchorElement) {
    anchorElement.scrollIntoView({
      block: 'start',
      // behavior: 'smooth'
      behavior: 'auto'
    })
  }
}

const alertRedImg = ref('')
EventBus.on('alertRedImg', (img: string) => {
  alertRedImg.value = img;
  // newGuide()

  // const newGuide = Storage.get("newGuide");
  if (th != 'th') {
    checkAlertAvt()
  }

  // if (newGuide == null) {
  //   //先开启新手引导，等新手引导完了再开启活动
  //   toGuide.value = true;
  // } else {
  //   checkAlertAvt()
  // }

})
//一天只弹一次广告
const checkAlertAvt = () => {
  const time = new Date().getTime();
  //今天的日期
  const day = formatDate(time);
  const storageDay = Storage.get("alertAvt");
  if (storageDay != day) {
    alertAd.value = true;
  }
}
const showDownApp = ref(0); // 是否显示顶部下载栏. 0-不显示 1-显示下载APP按钮, 2-显示下载App和添加到桌面
const showUrlList = ref(false)

EventBus.on("getServerConfig", () => {
  checkWebclip();
  checkInvite(route);
});

const checkWebclip = () => {
  const isInvited = !!Platform.from_invite_code && Platform.from_invite_code !== '';
  showUrlList.value = !isInvited && forever_url.value.length > 0;

  if (standalone) {
    showDownApp.value = 0;
  } else if (os && os != "h5") {
    showDownApp.value = 0;
    Platform.client = os as string;
    guiType4Bottom.value = '0'
  } else if (!is_home_down_tab.value) {
    showDownApp.value = 0;
  } else {
    if (ios) {
      if (Platform.downUrlIos != "" && Platform.downUrlWebclip != "") {
        showDownApp.value = 2;
      } else if (Platform.downUrlIos != "") {
        showDownApp.value = 1;
      } else {
        showDownApp.value = 0;
      }
    } else {
      showDownApp.value = Platform.downUrlAndroid != "" ? 1 : 0;
    }
  }

  if (Platform.from_invite_code && Platform.from_invite_code !== '') {
    nativeToLogin(router);
  }
}
//检查今天签到了吗
const checkQD = () => {
  const time = new Date().getTime()
  //今天的日期
  const day = formatDate(time)
  const jfDay = Storage.get("jfStoreDay");
  if (jfDay && jfDay == day) {
    isQD.value = true;
  }
}
const hometab = (data) => {
  if (data == 4 && !is_has_history.value) {
    return active.value = 3;
  }
  active.value = data;
};
// const toJfStore = () => {

//   if (isYk.value) {

//     return nativeToLogin(router)
//   }
//   // const time = new Date().getTime()
//   // //今天的日期
//   // const day = formatDate(time)
//   // Storage.set("jfStoreDay", day);
//   // checkQD()
//   nativeToNewWeb(router, `/integralwallet?a=0`)
//   // router.push(`/integralwallet?token=${user.value.token}&&uid=${user.value.customerId}&&nav=0`);
// }

// const toWyc = () => {
//   let c = Platform.channel
//   if (!channel || c == 0) {
//     c = Number(process.env.VUE_APP_CHANNEL as string);
//   }
//   let o = os ? os : Platform.client
//   let wc = webclip ? webclip : ''
//   let fids = fid ? fid : ''
//   let custerId = customerId ? customerId : Storage.get("customerId");
//   let t = token ? token : Storage.get("token");

//   let url = night_url.value + "/#/?tabIdx=5&uid=" + user.value.uid + "&fastkey=" + user.value.fastkey + "&webclip=" + wc + "&os=" + o + "&fid=" + fids + "&customerId=" + custerId + "&channel=" + c + "&token=" + t;
//   window.location.replace(url)
// }

const toDownApp = () => {
  YMPush("DOWNLOAD", "首页下载")
  // toLocationBrowser(ios ? Platform.downUrlIos : Platform.downUrlAndroid);
  toDownloadApp();
  window.$apiNet.statisticsPost({ action_id: 1 });
}

const toDownWebclip = () => {
  // 安装网页签
  YMPush("DOWNLOAD", "首页下载")
  // toLocationBrowser(Platform.downUrlWebclip);
  toDownloadApp(true);
  window.$apiNet.statisticsPost({ action_id: 1 });
}

const swiperObj = ref(null);
const tabBgColor = ref("#f8f8f8")
const titleActiveColor = ref("#0D0D0D")
const titleInactiveColor = ref("#0D0D0DB2")
EventBus.on("swiperColor", (obj) => {
  if (!obj) return;
  swiperObj.value = obj;

  // if (active.value == 0) {
  //   tabBgColor.value = swiperObj.value.tabBgColor ? swiperObj.value.tabBgColor : "#f8f8f8"
  //   titleActiveColor.value = swiperObj.value.titleActiveColor ? swiperObj.value.titleActiveColor : "#0D0D0D"
  //   titleInactiveColor.value = swiperObj.value.titleInactiveColor ? swiperObj.value.titleInactiveColor : "#B3B3B3"
  // } else {
  // tabBgColor.value = "#f8f8f8"
  // titleActiveColor.value = "#0D0D0D"
  // titleInactiveColor.value = "#0D0D0DB2"
  // }
})

EventBus.on("jumpIndex", (obj) => {
  if (obj == 0) {
    active.value = 0
  } else if (obj == 99) {
    if (standalone) {
      let len = homeTabs.value.length + 1;
      active.value = len;
    }
  } else {
    for (let i = 0; i < homeTabs.value.length; i++) {
      let ht = homeTabs.value[i].type
      if (ht == obj) {
        active.value = i + 1;
      }
    }
  }
})

const getTabTypeByIndex = (index: number) => {
  if (index == 0) return 0;
  if (index > 0 && index <= homeTabs.value.length) {
    const currentTab = homeTabs.value[index - 1];
    return currentTab ? Number(currentTab.type) : null;
  }
  if (index == homeTabs.value.length + 1) {
    return 99;
  }
  return null;
}

const tabsChange = (index: number) => {
  if (!swiperObj.value) return;

  // if (index == 0) {
  //   tabBgColor.value = swiperObj.value.tabBgColor ? swiperObj.value.tabBgColor : "#f8f8f8"
  //   titleActiveColor.value = swiperObj.value.titleActiveColor ? swiperObj.value.titleActiveColor : "#0D0D0D"
  //   titleInactiveColor.value = swiperObj.value.titleInactiveColor ? swiperObj.value.titleInactiveColor : "#B3B3B3"
  // } else {
  // tabBgColor.value = "#f8f8f8"
  // titleActiveColor.value = "#0D0D0D"
  // titleInactiveColor.value = "#0D0D0DB2"
  if (getTabTypeByIndex(index) == 7) {
    window.$apiNet.statisticsPost({ action_id: 27 }); // 点击快讯统计
  }
  // }
}
const alertAd = ref(false)
const appName = process.env.VUE_APP_NAME;

const toActivity = () => {
  const time = new Date().getTime();
  //今天的日期
  const day = formatDate(time);
  Storage.set("alertAvt", day);
  alertAd.value = false;
  window.$apiNet.statisticsPost({ action_id: 26 });
  if (home_red_url_type.value == 1) {
    nativeToNewWeb(router, `/activityDetail?id=${alertToActivityId.value}`)
  } else {
    window.location.href = home_red_url.value;
  }
}
const offActivity = () => {
  const time = new Date().getTime();
  //今天的日期
  const day = formatDate(time);
  Storage.set("alertAvt", day);
  alertAd.value = false;
}

const guiType4Bottom = ref('50px')




const __returned__ = { curversion, t, HomeIndexVi, ConfigpiniaStore, home_red_url_type, home_red_url, alertToActivityId, is_has_history, is_home_down_tab, forever_url, home_lefttop_white_gif, home_lefttop_black_gif, getConfig, route, piniaStore, toLogin, activeColor, activeFontColor, active, WORLD_CUP_TAB_TYPE, homexbod, homexadBtn, searchIcon, url_list_close, url_list_ok, url_list_con_title, isQD, time5, homeTabs, showHomeTabs, os, tabIdx, standalone, ios, th, appname, appChannel, getHomeTabs, compareVersions, newGuide, toGuide, guideType, nextGuide, scrollToAnchor, alertRedImg, checkAlertAvt, showDownApp, showUrlList, checkWebclip, checkQD, hometab, toDownApp, toDownWebclip, swiperObj, tabBgColor, titleActiveColor, titleInactiveColor, getTabTypeByIndex, tabsChange, alertAd, appName, toActivity, offActivity, guiType4Bottom, HomeIndex, Newsletter, HomeFootball, HomeWorldCup, router }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})